<app-header></app-header>
<div class="responsive">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <app-sidebar></app-sidebar>
      </div>
      <!-- Chat section Start -->

      <section class="message-area">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="chat-area">
                <!-- chatlist -->
                <div class="chatlist">
                  <div class="modal-dialog-scrollable">
                    <div class="modal-content">
                      <div class="chat-header">
                        <div class="msg-search">
                          <input
                            type="text"
                            class="form-control"
                            id="inlineFormInputGroup"
                            placeholder="Search..."
                            aria-label="search"
                            [(ngModel)]="searchTerm"
                            (ngModelChange)="filterUsers()"
                          />
                        </div>
                        <ul
                          class="nav nav-pills nav-tabs nav-chat"
                          role="tablist"
                          id="chat-tab"
                        >

                          <li class="nav-item" role="presentation">
                            <button
                              class="nav-link"
                              id="public-tab"
                              data-toggle="pill"
                              data-target="#public"
                              type="button"
                              (click)="getSelectedTab('Public')"
                              role="tab"
                              aria-controls="public"
                              [attr.aria-selected]="activeTab==='Public'"
                              [ngClass]="{active: activeTab==='Public'}"
                            >
                              Public
                            </button>
                          </li>

                          <li class="nav-item" role="presentation">
                            <button
                              class="nav-link"
                              id="affiliate-tab"
                              data-toggle="pill"
                              data-target="#affiliate"
                              type="button"
                              (click)="getSelectedTab('Affiliate')"
                              role="tab"
                              aria-controls="affiliate"
                              [attr.aria-selected]="activeTab==='Affiliate'"
                              [ngClass]="{active: activeTab==='Affiliate'}"
                            >
                              Affiliate
                            </button>
                          </li>

                          <li class="nav-item" role="presentation">
                            <button
                              class="nav-link"
                              id="merchants-tab"
                              data-toggle="pill"
                              data-target="#merchants"
                              type="button"
                              role="tab"
                              (click)="getSelectedTab('Merchants')"
                              aria-controls="merchants"
                              [attr.aria-selected]="activeTab==='Merchants'"
                              [ngClass]="{active: activeTab==='Merchants'}"
                            >
                              Merchants
                            </button>
                          </li>

                          <li class="nav-item" role="presentation">
                            <button
                              class="nav-link"
                              id="ministries-tab"
                              data-toggle="pill"
                              data-target="#ministries"
                              type="button"
                              role="tab"
                              (click)="getSelectedTab('Ministries')"
                              aria-controls="ministries"
                              [attr.aria-selected]="activeTab==='Ministries'"
                              [ngClass]="{active: activeTab==='Ministries'}"
                            >
                              Ministries
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div class="modal-body">
                        <!-- chat-list -->
                        <div class="chat-lists">
                          <!-- All Tabs user List (All tab) -->
                          <div class="tab-content" id="chat-tabContent">
                            

                            <!-- TAB: Public (Followers) -->
                            <div class="tab-pane fade" id="public" role="tabpanel" aria-labelledby="public-tab" [ngClass]="{'show active': activeTab==='Public'}">
                              <ng-container
                                *ngIf="publicUsers?.length > 0; else noPublic"
                              >
                                <div
                                  class="chat-list"
                                  *ngFor="let user of publicUsers"
                                >
                                  <div
                                    href="#"
                                    class="d-flex align-items-center singleUser"
                                    (click)="initiateFellowshipChat(user)"
                                    style="cursor: pointer"
                                  >
                                    <div class="flex-shrink-0">
                                      <img
                                        *ngIf="user.photo"
                                        class="img-fluid userimg"
                                        [src]="setUrl(user)"
                                        alt="user img"
                                        (error)="onImageError($event)"
                                      />
                                      <img
                                        *ngIf="!user.photo"
                                        class="img-fluid userimg"
                                        src="assets/person.png"
                                        alt="default avatar"
                                      />
                                    </div>
                                    <div
                                      class="flex-grow-1 mx-2"
                                      (click)="getUserChat(user)"
                                    >
                                      <h3>{{ user.name || user.userName }}</h3>
                                      <p *ngIf="user.unReadMessage == 0">
                                        {{
                                          user?.message[
                                            user?.message?.length - 1
                                          ]?.message
                                        }}<span></span>
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #noPublic>
                                <div class="text-center mt-3 text-muted">
                                  No record found
                                </div>
                              </ng-template>
                            </div>

                            <!-- TAB: Affiliate -->
                            <div class="tab-pane fade" id="affiliate" role="tabpanel" aria-labelledby="affiliate-tab" [ngClass]="{'show active': activeTab==='Affiliate'}">
                              <ng-container
                                *ngIf="affiliateUsers?.length > 0; else noAffiliate"
                              >
                                <div class="chat-list" *ngFor="let user of affiliateUsers">
                                  <div
                                    href="#"
                                    class="d-flex align-items-center singleUser"
                                    (click)="initiateFellowshipChat(user)"
                                  >
                                    <div class="flex-shrink-0">
                                      <ng-container *ngIf="user?.photo; else defaultAvatar">
                                        <img
                                          class="img-fluid userimg"
                                          [src]="setUrl(user)"
                                          alt="user img"
                                          (error)="onImageError($event)"
                                        />
                                      </ng-container>
                                      <ng-template #defaultAvatar>
                                        <img
                                          class="img-fluid userimg"
                                          src="../../../../assets/person.png"
                                          alt="default avatar"
                                        />
                                      </ng-template>
                                    </div>
                                    <div class="flex-grow-1 mx-2" (click)="getUserChat(user)">
                                      <h3>{{ user.name || user.userName }}</h3>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #noAffiliate>
                                <div class="text-center mt-3 text-muted">No record found</div>
                              </ng-template>
                            </div>
                            <!-- TAB: Ministries/Partners user list -->
                            <div
                              class="tab-pane fade"
                              id="merchants"
                              role="tabpanel"
                              aria-labelledby="merchants-tab"
                              [ngClass]="{'show active': activeTab==='Merchants'}"
                            >
                              <ng-container
                                *ngIf="
                                  partnersUserList?.length > 0;
                                  else noMerchants
                                "
                              >
                                <div
                                  class="chat-list"
                                  *ngFor="let user of partnersUserList"
                                >
                                  <div
                                    href="#"
                                    class="d-flex align-items-center singleUser"
                                    (click)="initiateFellowshipChat(user)"
                                  >
                                    <div class="flex-shrink-0">
                                      <ng-container
                                        *ngIf="
                                          user?.user?.photo;
                                          else defaultAvatar
                                        "
                                      >
                                        <img
                                          class="img-fluid userimg"
                                          [src]="
                                            setUrl(
                                              user?.user?.photo || user?.photo
                                            )
                                          "
                                          alt="user img"
                                        />
                                      </ng-container>
                                      <ng-template #defaultAvatar>
                                        <img
                                          class="img-fluid userimg"
                                          src="../../../../assets/person.png"
                                          alt="default avatar"
                                        />
                                      </ng-template>
                                    </div>
                                    <div
                                      class="flex-grow-1 mx-2"
                                      (click)="getUserChat(user.user || user)"
                                    >
                                      <h3>
                                        {{ user?.user?.name || user?.name || user?.userName}}
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #noMerchants>
                                <div class="text-center mt-3 text-muted">
                                  No record found
                                </div>
                              </ng-template>
                            </div>

                            <div
                              class="tab-pane fade"
                              id="ministries"
                              role="tabpanel"
                              aria-labelledby="ministries-tab"
                              [ngClass]="{'show active': activeTab==='Ministries'}"
                            >
                              <ng-container
                                *ngIf="
                                  partnersUserList?.length > 0;
                                  else noMinistries
                                "
                              >
                                <div
                                  class="chat-list"
                                  *ngFor="let user of partnersUserList"
                                >
                                  <div
                                    href="#"
                                    class="d-flex align-items-center singleUser"
                                    (click)="initiateFellowshipChat(user)"
                                  >
                                    <div class="flex-shrink-0">
                                      <ng-container
                                        *ngIf="
                                          user?.user?.photo;
                                          else defaultAvatar
                                        "
                                      >
                                        <img
                                          class="img-fluid userimg"
                                          [src]="
                                            setUrl(
                                              user?.user?.photo || user?.photo
                                            )
                                          "
                                          alt="user img"
                                        />
                                      </ng-container>
                                      <ng-template #defaultAvatar>
                                        <img
                                          class="img-fluid userimg"
                                          src="../../../../assets/person.png"
                                          alt="default avatar"
                                        />
                                      </ng-template>
                                    </div>
                                    <div
                                      class="flex-grow-1 mx-2"
                                      (click)="getUserChat(user.user || user)"
                                    >
                                      <h3>
                                        {{ user?.user?.name || user?.name || user?.userName}}
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-template #noMinistries>
                                <div class="text-center mt-3 text-muted">
                                  No record found
                                </div>
                              </ng-template>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- chatlist -->

                <!-- chatbox -->
                <div class="chatbox showbox">
                  <div class="message-header">
                    <div class="dropdown new-chat-dropdown" style="display:flex; justify-content:flex-end">
                      <button 
                        class="btn btn-primary dropdown-toggle new-chat-btn" 
                        type="button" 
                        id="newChatDropdown" 
                        aria-expanded="false"
                        (click)="chatOption()"
                      >
                        New Chat
                      </button>
                      <ul class="dropdown-menu custom-dropdown" [class.show]="showNewChatDropdown">
                        <li><a class="dropdown-item" href="#" (click)="newChat('affiliates'); $event.preventDefault()"><i class="fas fa-user me-2"></i> &nbsp;Affiliates</a></li>
                        <li><a class="dropdown-item" href="#" (click)="newChat('ministries'); $event.preventDefault()"><i class="fas fa-store me-2"></i>&nbsp;Ministries</a></li>
                      </ul>
                    </div>
                  </div>
                  <!-- Scrollable list of users -->
                  <div *ngIf="showNewChatList" class="new-chat-list">
                    <div class="chat-list-header">
                      <h6 class="mb-0"><i class="fas fa-users me-2"></i>Select User to Chat</h6>
                      <button
                        class="btn btn-sm btn-outline-danger close-btn"
                        (click)="closeNewChatList()"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </div>
                    <div class="user-scroll">
                      <ng-container *ngIf="newChatUser.length > 0; else noUsers">
                        <div
                          *ngFor="let user of newChatUser"
                          class="user-item modern-user-card"
                          (click)="initiateFellowshipChat(user)"
                        >
                          <div class="user-avatar">
                            <ng-container *ngIf="user.photo; else defaultImage">
                              <img
                                class="img-fluid userimg"
                                [src]="setUrl(user)"
                                alt="user img"
                                (error)="onImageError($event)"
                              />
                            </ng-container>
                            <ng-template #defaultImage>
                              <img
                                src="../../../../assets/person.png"
                                alt="user"
                                class="user-photo"
                              />
                            </ng-template>
                          </div>
                          <div class="user-info">
                            <h6 class="user-name">{{ user.name || user.userName || (user.firstName + ' ' + user.lastName) }}</h6>
                            <small class="user-status text-muted">
                              <i class="fas fa-circle online-indicator"></i>Available
                            </small>
                          </div>
                          <div class="chat-action">
                            <i class="fas fa-comment-dots"></i>
                          </div>
                        </div>
                      </ng-container>

                      <!-- Fallback when no users are found -->
                      <ng-template #noUsers>
                        <div class="text-center text-muted mt-3">No record found</div>
                      </ng-template>
                    </div>
                  </div>

                  <!-- Scrollable list close of users -->

                  <div class="modal-dialog-scrollable">
                    <div class="modal-content" *ngIf="chatStatus">
                      <div class="msg-head">
                        <div class="row">
                          <div class="col-8">
                            <div class="d-flex align-items-center">
                              <span class="chat-icon"> </span>
                              <div class="flex-shrink-0">
                                <ng-container
                                  *ngIf="activeUser[0].photo; else defaultAvatar"
                                >
                                  <img
                                    class="img-fluid userimg"
                                    [src]="setUrl(activeUser[0])"
                                    alt="user img"
                                    (error)="onImageError($event)"
                                    [style.width]="'40px'"
                                    [style.height]="'40px'"
                                  />
                                </ng-container>
                                <ng-template #defaultAvatar>
                                  <img
                                    class="img-fluid userimg"
                                    src="../../../../assets/person.png"
                                    alt="default avatar"
                                    width="30px"
                                  />
                                </ng-template>
                              </div>
                              <div class="flex-grow-1 mx-2">
                                <h3>{{activeUser[0].userName || activeUser[0].name || activeUser[0].lastName }}</h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="modal-bodys" style="height: 280px">
                        <div class="msg-body" #chatContainer>
                          <ul>
                            <li
                              *ngFor="let data of chat"
                              [ngClass]="{
                                sender: data.senderId !== loginUser,
                                repaly: data.senderId === loginUser
                              }"
                            >
                              <p>{{ data.message }}</p>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="send-box">
                        <div style="display: flex">
                          <input
                            type="text"
                            class="form-control"
                            aria-label="message…"
                            [(ngModel)]="newMessage"
                            (ngModelChange)="getMessageInput($event)"
                            (keyup.enter)="sendMessage()"
                            placeholder="Enter your message..."
                          />
                          <button (click)="sendMessage()" type="button">
                            <i class="fa fa-paper-plane" aria-hidden="true"></i>
                            Send
                          </button>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="modal-content" *ngIf="!chatStatus">
                      <h5 class="chatCenter">Chat</h5>
                    </div> -->
                  </div>
                </div>
                <!-- chatbox -->
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Chat section end -->
    </div>
  </div>
</div>
